import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#081428] text-[#EAEAEA]">
      <Navbar />
      <main className="container mx-auto px-8 md:px-32 lg:px-48 xl:px-64 pt-24 pb-12">
        <h1 className="text-4xl font-bold mb-8">Política de Privacidade</h1>
        <h2 className="text-2xl font-semibold mb-6">Política de Privacidade da LawX</h2>
        
        <p className="mb-8 text-gray-300">
          A LawX, uma empresa voltada para inteligência artificial para advogados, está comprometida em proteger a privacidade dos 
          usuários de seus serviços. A Política de Privacidade a seguir descreve como coletamos, usamos, compartilhamos e protegemos 
          as informações pessoais dos usuários.
        </p>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">1. Informações do Usuário</h3>
          <p className="text-gray-300">
            É importante coletarmos algumas informações dos usuários para melhorar nossos serviços e oferecer um site mais direcionado 
            às suas preferências. Também utilizamos essas informações para informar sobre novidades e informações relevantes. No 
            entanto, garantimos que quaisquer informações pessoais dos usuários não serão fornecidas, publicadas ou comercializadas em 
            quaisquer circunstâncias, exceto nos casos em que o usuário participar de algum comentário ou postagem, onde o nome, o 
            email e o depoimento poderão ser publicados, de acordo com nossos termos de uso.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">2. Cadastro</h3>
          <p className="text-gray-300">
            Nunca enviamos e-mails solicitando confirmação de dados/cadastro ou com anexos executáveis ou links para download. Para 
            usufruir dos benefícios adicionais do site e receber informações sobre nossos serviços, é necessário se cadastrar em algum de 
            nossos formulários de opt-in. O cadastro é armazenado em um banco de dados protegido e sigiloso. Caso o usuário não 
            deseje mais receber nossos informativos, basta clicar no link de cancelamento presente no rodapé de cada mensagem ou nos 
            avisar por e-mail. Nós nunca enviamos spam.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">3. Cookies</h3>
          <p className="text-gray-300">
            O site utiliza cookies e outras tecnologias similares para melhorar a experiência do usuário, permitindo reconhecê-lo e 
            identificar suas preferências. Ao navegar pelo site, o usuário automaticamente aceita nossa política de cookies. Os cookies 
            podem ser desativados nas configurações do navegador, mas isso pode afetar o funcionamento de alguns recursos do site.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">4. Segurança</h3>
          <p className="text-gray-300">
            Mantemos salvaguardas físicas, eletrônicas e procedimentais apropriadas para proteger as informações pessoais contra 
            destruição acidental ou ilegal, perda acidental, alteração, divulgação ou acesso não autorizado. Nossos procedimentos de 
            segurança são continuamente revisados com base em novas tecnologias.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">5. Alterações na Política de Privacidade</h3>
          <p className="text-gray-300">
            Reservamos o direito de modificar esta política de privacidade a qualquer momento. Alterações significativas serão 
            comunicadas aos usuários através de aviso em nosso site. O uso continuado de nossos serviços após tais modificações 
            constitui aceitação das alterações.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold mb-4">6. Contato</h3>
          <p className="text-gray-300">
            Para questões relacionadas a esta Política de Privacidade, entre em contato conosco através do e-mail: contato@lawx.ai
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
